import React from 'react';
import { Divider } from 'antd';

export default class extends React.Component {
  render() {
    const { details, columnMap } = this.props;

    return (
      <div>
        {Object.keys(details).map((key, index) => {
          return (
            <div key={key}>
              {index > 0 && <Divider />}
              {key !== 'orderItems' && (
                <div className="orders__details">
                  <div className="orders__detail-title">
                    {columnMap[key] || key}
                  </div>
                  <div className="orders__detail-data">
                    {details[key] && typeof details[key] === 'string'
                      ? details[key]
                      : ''}
                  </div>
                </div>
              )}
              {key === 'orderItems' &&
                details[key] &&
                details[key].length && (
                  <div className="orders__details-items">
                    <div className="orders__detail-title">
                      {columnMap[key] || key}
                    </div>
                    {details[key].map((item, index) => {
                      return (
                        <div
                          className="orders__details-items-container"
                          key={index}
                        >
                          {Object.keys(item).map(name => {
                            return (
                              <div className="orders__details" key={name}>
                                <div className="orders__detail-title">
                                  {name}
                                </div>
                                <div className="orders__detail-data">
                                  {item[name] && typeof item[name] === 'string'
                                    ? item[name]
                                    : ''}
                                </div>
                              </div>
                            );
                          })}
                          {index < details[key].length - 1 && <Divider />}
                        </div>
                      );
                    })}
                  </div>
                )}
            </div>
          );
        })}
      </div>
    );
  }
}
